import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Flower2, Sun, Leaf, Snowflake, Pencil, Castle, BookOpen, Heart, Star, Palette, Puzzle, Music, Shapes, Apple, Bird } from "lucide-react";

export const ICONS = { flower: Flower2, sun: Sun, leaf: Leaf, snowflake: Snowflake, pencil: Pencil, castle: Castle, book: BookOpen, heart: Heart, star: Star, palette: Palette, puzzle: Puzzle, music: Music, shapes: Shapes, apple: Apple, bird: Bird };
export const CatIcon = ({ name, className }) => {
  const I = ICONS[name] || Flower2;
  return <I className={className} strokeWidth={1.6} />;
};

export const Daisy = ({ size = 48, petals = 8, center = "#F2C230", petal = "#fff", className = "", animatePetals = false }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" className={className} aria-hidden="true">
    {Array.from({ length: petals }).map((_, i) => (
      <g key={i} transform={`rotate(${(360 / petals) * i} 50 50)`}>
        {animatePetals ? (
          <motion.ellipse cx="50" cy="24" rx="11" ry="22" fill={petal} initial={{ scale: 0, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.1 + i * 0.09, type: "spring", stiffness: 180, damping: 12 }} style={{ originX: "50px", originY: "50px", transformBox: "view-box" }} />
        ) : (
          <ellipse cx="50" cy="24" rx="11" ry="22" fill={petal} />
        )}
      </g>
    ))}
    {animatePetals ? (
      <motion.circle cx="50" cy="50" r="13" fill={center} initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 0.9, type: "spring" }} />
    ) : (
      <circle cx="50" cy="50" r="13" fill={center} />
    )}
  </svg>
);

export const DaisyBadge = ({ size = 56, className = "" }) => (
  <span className={`inline-flex items-center justify-center rounded-full bg-[#A3AC86] ${className}`} style={{ width: size, height: size }}>
    <Daisy size={size * 0.72} />
  </span>
);

export const Logo = ({ light = false }) => (
  <Link to="/" data-testid="header-logo" className="group flex items-center gap-3 shrink-0">
    <span className="transition-transform duration-700 group-hover:rotate-[120deg]"><DaisyBadge size={50} className="sm:!h-[58px] sm:!w-[58px]" /></span>
    <span className={`h-display leading-[0.85] text-[19px] sm:text-[26px] ${light ? "!text-white" : ""}`}>
      hravá<br />mateřinka
    </span>
  </Link>
);

export const FlowerBlob = ({ className = "", color = "#A3AC86" }) => (
  <svg viewBox="0 0 200 200" className={className} aria-hidden="true">
    <g fill={color}>
      {Array.from({ length: 6 }).map((_, i) => {
        const a = (i * Math.PI) / 3;
        return <circle key={i} cx={100 + Math.cos(a) * 52} cy={100 + Math.sin(a) * 52} r="44" />;
      })}
      <circle cx="100" cy="100" r="60" />
    </g>
  </svg>
);

export const Wave = ({ fill = "#E9EFE0", flip = false, className = "" }) => (
  <svg viewBox="0 0 1440 90" preserveAspectRatio="none" className={`block w-full h-[50px] md:h-[80px] ${flip ? "rotate-180" : ""} ${className}`} aria-hidden="true">
    <path d="M0,40 C240,95 420,0 720,38 C1010,75 1200,10 1440,45 L1440,90 L0,90 Z" fill={fill} />
  </svg>
);
